import React from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import PropTypes from 'prop-types'

// Components
import { StatusBanner, S_StatusBanner } from '../_components/StatusBanner'

// Helpers
import { formatCurrency, formatIneligible, formatPercentage } from '../_helpers/formatting'

// Constants
import { colors } from '../_constants/colors'

// Styled Components
export const StyledOverviewStats = styled.div`
  .stat {
    display: block;
    padding-bottom: 15px;
    border-bottom: 1px solid #ddd;
    margin-bottom: 15px;
    &:last-of-type {
      padding-bottom: 0;
      border-bottom: none;
      margin-bottom: 0;
    }

    .inner {
      display: flex;
      justify-content: space-between;
      width: 100%;
    }

    .label {
      margin-right: 10px;
    }

    .value {
      text-align: right;
    }

    .warning {
      color: ${colors.MATERIAL_RED};
    }

    ${S_StatusBanner} {
      margin-top: 15px;
    }
  }
`

const getFormattedValue = (statType, stat) => {
  switch (statType) {
    case 'currency':
      return !isNaN(Number(stat)) ? formatCurrency(stat) : formatCurrency(0)
    case 'ineligible':
      return formatIneligible(stat)
    case 'percent':
      return formatPercentage(stat)
    case 'number':
      return new Intl.NumberFormat().format(stat)
    default:
      return stat
  }
}

const OverviewStats = ({ additional_stats, business, lenderBusiness, override, stats }) => {
  if (lenderBusiness) {
    business = lenderBusiness
  }
  business = { ...business, ...additional_stats }
  return (
    <StyledOverviewStats className={`stats`}>
      {stats.map((stat, i) => {
        // Don't show stats if no value is defined
        if (business[stat.name] === undefined || business[stat.name] === null) {
          return null
        }
        let value = business[stat.name].value || business[stat.name]
        if (override && override.key === stat.name) {
          value = override.value
        }
        const { label, type, negativeWarning, name } = stat
        const showWarning = type === 'currency' && value < 0 && name !== 'client_balance'
        return (
          <div className={`stat`} key={i}>
            <div className={`inner ${showWarning && 'warning'}`}>
              <span className={`label`}>{label}</span>
              <span className={`value`}>{getFormattedValue(type, value)}</span>
            </div>

            {/* Negative warning - if applicable */}
            {showWarning && !!negativeWarning && <StatusBanner icon="!" message={negativeWarning} />}
          </div>
        )
      })}
    </StyledOverviewStats>
  )
}

function mapStateToProps(state) {
  const { business } = state
  return {
    business,
  }
}

const connectedOverviewStats = connect(mapStateToProps)(OverviewStats)
export { connectedOverviewStats as OverviewStats }

OverviewStats.propTypes = {
  stats: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
    })
  ),
  additional_stats: PropTypes.objectOf(
    PropTypes.shape({
      amount: PropTypes.number.isRequired,
      currency: PropTypes.string.isRequired,
      value: PropTypes.number.isRequired,
    })
  ),
}
